import { http } from "@/http";
import { Study } from "@/psychlab/types";

export const createStudy = async(config:{ name?:string, blueprint:string, language?:string }):Promise<Study> => {
	const { data } = await http.post("studies", config);
	return data;
};